<template>
    <div>
        {{info}}
    </div>
</template>

<script>
    import MobileDetect from 'mobile-detect'
    import JSCSSUtil from "../utils/JSCSSUtil";
    export default {
        name: "MobileInfo",
        data() {
          return {
              info: ''
          }
        },
        created() {

        },

        mounted() {
            debugger
            let ua = navigator.userAgent
            console.log(ua)
            var md = new MobileDetect(ua)
            var os = md.os();
            var model = "";
            if (os == "iOS") {//ios系统的处理
                os = md.os() + md.version("iPhone");
                model = md.mobile();
            } else if (os == "AndroidOS") {//Android系统的处理
                os = md.os() + md.version("Android");
                var sss = ua.split(";");
                var i = sss.findIndex(item => item.indexOf("Build/") > -1);
                if (i > -1) {
                    model = sss[i].substring(0, sss[i].indexOf("Build/"));
                }

                model == "" ? model = sss[2] : "default"

            }
            this.info = os + "===" + model + "===" + md.versionStr('Build')

            JSCSSUtil.delayLoadJS("http://pv.sohu.com/cityjson?ie=utf-8").then(res => {
                console.log(res);
                var ip=returnCitySN.cip

                this.info = os + "===" + model + "===" + md.versionStr('Build') + "===" + ip + "===" + ua
            })
        }
    }
</script>

<style scoped>

</style>
